import { Vocabulary } from "./Vocabulary";

interface TikTokPurchaseEvent {
  value: number;
  orderId: string;
}

/**
 * Load TikTok Pixel script.
 * Prevent duplicate insertion by checking if the TikTok Pixel script element already exists.
 * Create the main TikTok Pixel script element and append it to the document head.
 * @param {string} pixelId - The ID of the TikTok Pixel container.
 */
export const loadTikTokPixel = (pixelId: string): void => {
  // Prevent duplicate script loading
  if (document.getElementById("ttq-script")) return;

  // ---- Create TikTok Pixel script ----
  const script = document.createElement("script");
  script.id = "ttq-script";
  script.async = true;
  script.text = `
    !function (w, d, t) {
      w.TiktokAnalyticsObject = t;
      var ttq = w[t] = w[t] || [];
      ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "upload"];
      ttq.setAndDefer = function (t, e) {
        t[e] = function () {
          t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
        };
      };
      for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
      ttq.instance = function (t) {
        var e = ttq._i[t] || [];
        for (var n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]);
        return e;
      };
      ttq.load = function (e, n) {
        var i = "https://analytics.tiktok.com/i18n/pixel/events.js";
        ttq._i = ttq._i || {};
        ttq._i[e] = [];
        ttq._i[e]._u = i;
        ttq._t = ttq._t || {};
        ttq._t[e] = +new Date();
        ttq._o = ttq._o || {};
        ttq._o[e] = n || {};
        var o = document.createElement("script");
        o.type = "text/javascript";
        o.async = true;
        o.src = i + "?sdkid=" + e + "&lib=" + t;
        var a = document.getElementsByTagName("script")[0];
        a.parentNode.insertBefore(o, a);
      };
      ttq.load('${pixelId}');
      ttq.page();
    }(window, document, 'ttq');
  `;

  document.head.appendChild(script);
};

export const sendPurchaseEventTikTok = ({
  value,
  orderId,
}: TikTokPurchaseEvent) => {
  if (typeof window !== "undefined" && (window as any).ttq) {
    (window as any).ttq.track("Purchase", {
      value,
      currency: "RON",
      contents: [
        {
          content_id: orderId,
          content_type: "product",
          content_name: "Avans",
          quantity: 1,
        },
      ],
    });
  }
};

/**
 * Sends a TikTok lead event using ttq.
 *
 * @param {any} client - Client data.
 * @param {any} selectedProduct - Selected product data.
 * @param {string} selectedPrice - Selected price.
 *
 * @example
 * sendLeadEventTikTok({
 *   firstName: 'John',
 *   lastName: 'Doe',
 *   email: 'john@example.com',
 *   phone: '0741234567',
 * }, {
 *   name: 'Product A',
 * }, '100.00');
 */
export function sendLeadEventTikTok(
  client: any,
  selectedProduct: any,
  selectedPrice: string
) {
  if (typeof window !== "undefined" && (window as any).ttq) {
    (window as any).ttq.track("Lead", {
      event_label: Vocabulary.advance + " " + selectedProduct?.name,
      product: selectedProduct?.name,
      value: selectedPrice,

      currency: "RON",
      client_name: client.firstName + " " + client.lastName,
      client_email: client?.email,
      client_phone: client?.phone,
    });
  }
}
